import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import {
	resetUploadSampleFileOfCurrencyRate,
	uploadSampleFileOfCurrencyRateapi
} from "../../redux/actions/uploadSampleFileOfCurrencyRateAction";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import PublishIcon from "@mui/icons-material/Publish";
import GetAppIcon from "@mui/icons-material/GetApp";

import {
	resetDownloadSampleFileOfCurrencyRate,
	downloadSampleFileOfCurrencyRateApi
} from "../../redux/actions/downloadSampleFileOfCurrencyRateAction";

import success from "../../assets/img/success.png";
import BackButton from "../../components/BackButton/BackButton";
import { FileExcelFilled, FilePdfFilled } from "@ant-design/icons";
import FileBase64 from "../../components/Upload/UploadFile";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const ConversionRate = () => {
	const classes = useStyles();
	const [uploadFile, setUploadFile] = useState("");
	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [
		downloadSampleFileOfCurrencyRateStatus,
		SetdownloadSampleFileOfCurrencyRateStatus
	] = useState(false);
	//uploadSampleFileOfCurrencyRateRes
	const [uploadSampleFileStatus, setUploadSampleFileStatus] = useState(false);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "uploadFile") {
			setUploadFile(value);
		}
	};

	const downloadSampleFileOfCurrencyRate = () => {
		SetdownloadSampleFileOfCurrencyRateStatus(true);
		const downloadSampleFileOfCurrencyRateReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(
			downloadSampleFileOfCurrencyRateApi(
				downloadSampleFileOfCurrencyRateReq,
				authToken
			)
		);
	};

	const downloadSampleFileOfCurrencyRateRes = useSelector(
		({ downloadSampleFileOfCurrencyRate }) => downloadSampleFileOfCurrencyRate
	);

	const uploadSampleFileOfCurrencyRateRes = useSelector(
		({ uploadSampleFileOfCurrencyRate }) => uploadSampleFileOfCurrencyRate
	);

	useEffect(() => {
		if (downloadSampleFileOfCurrencyRateStatus) {
			if (downloadSampleFileOfCurrencyRateRes.data.status == "success") {
				var link = document.createElement("a");
				link.download = downloadSampleFileOfCurrencyRateRes.data.fileName;
				link.href =
					"data:application/octet-stream;base64," +
					downloadSampleFileOfCurrencyRateRes.data.fileDate.split(`,`)[1];
				link.click();
			}
			// if (downloadSampleFileOfCurrencyRateRes.data.status == "Failed") {

			// }
		}
	}, [downloadSampleFileOfCurrencyRateRes.data.status]);

	const uploadSampleFileOfCurrencyRates = () => {
		setUploadSampleFileStatus(true);
		const fd = new FormData();
		const downloadSampleFileOfCurrencyRateReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				currencyFile: uploadFile.split(",")[1]
			}
		};

		return dispatch(
			uploadSampleFileOfCurrencyRateapi(
				downloadSampleFileOfCurrencyRateReq,
				authToken
			)
		);
	};

	useEffect(() => {
		if (uploadSampleFileStatus) {
			if (uploadSampleFileOfCurrencyRateRes.data.status == "success") {
				swalWithBootstrapButtons.fire({
					type: "success",
					title: "Upload File Successfully"
				});
			}
			if (uploadSampleFileOfCurrencyRateRes.data.status == "failed") {
				swalWithBootstrapButtons.fire({
					type: "error",
					title: " File  is Not Upload"
				});
				if (
					uploadSampleFileOfCurrencyRateRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					uploadSampleFileOfCurrencyRateRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (uploadSampleFileOfCurrencyRateRes.data.status == "Failed") {
				swalWithBootstrapButtons.fire({
					type: "error",
					title: " File  is Not Upload"
				});
				if (
					uploadSampleFileOfCurrencyRateRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					uploadSampleFileOfCurrencyRateRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}, [uploadSampleFileOfCurrencyRateRes.data.status]);

	const [UploadFileName, setUploadFileName] = useState("");

	const handleAttachmentsDoc = (e, uploadFile) => {
		if (uploadFile == "uploadFile") {
			setUploadFile(e.base64);
			setUploadFileName(e.name);
			setBtnDisable(false);
		}
	};

	const [btnDisable, setBtnDisable] = useState(true);

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem", textAlign: "center" }}
					>
						<Grid
							className="d-flex align-items-center justify-content-center"
							item
							xs={12}
							sm={12}
							md={4}
							lg={4}
						>
							<p style={{ fontSize: "18px", margin: "0" }}>Select Rate File </p>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							{/* <input
                name="uploadFile"
                value={uploadFile}
                className="my-2"
                type="file"
                placeholder="Browse"
                onChange={handleChange}
              /> */}

							<FileBase64
								className="themeText"
								multiple={false}
								name={false}
								id="documentGuard"
								accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
								onDone={(e) => handleAttachmentsDoc(e, "uploadFile")}
								showUploadList={false}
								value={UploadFileName}
							/>
							{UploadFileName ? UploadFileName : ""}

							{/* <Button
                style={{
                  marginLeft: "0.2rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                className="riskRuleButton"
              >
                Browse
              </Button> */}
						</Grid>
						<Grid item sm={12} md={4} lg={4}>
							{/* <Button
								style={{
									marginLeft: "0.2rem",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								className="riskRuleButton"
								onClick={downloadSampleFileOfCurrencyRate}
								endIcon={
									<FileExcelFilled
										style={{ color: "#fff", fontSize: "16px" }}
									/>
								}
							>
								Sample File Format
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={downloadSampleFileOfCurrencyRate}
							// endIcon={<SaveIcon />}
							>
								Sample File Format{" "}
								<FileExcelFilled style={{ color: "#fff", fontSize: "16px" }} />
							</CustomButton>
						</Grid>
					</Grid>

					<Grid
						container
						style={{
							padding: "25px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={4} className="text-center">
							{btnDisable ? (
								// <Button
								// 	style={{
								// 		backgroundColor: "#80dcfa",
								// 		color: "white"
								// 	}}
								// 	variant="contained"
								// 	className="riskRuleButton"
								// 	onClick={uploadSampleFileOfCurrencyRates}
								// 	endIcon={<PublishIcon />}
								// 	disabled={btnDisable}
								// >
								// 	Upload
								// </Button>
								<CustomButton
									disabled={btnDisable}
									style={{
										padding: "8px"
									}}
									onClick={uploadSampleFileOfCurrencyRates}
								// endIcon={<SaveIcon />}
								>
									Upload <PublishIcon />
								</CustomButton>
							) : (
								// <Button
								// 	style={{
								// 		backgroundColor: "#00b9f5",
								// 		color: "white"
								// 	}}
								// 	variant="contained"
								// 	className="riskRuleButton"
								// 	onClick={uploadSampleFileOfCurrencyRates}
								// 	endIcon={<PublishIcon />}
								// 	disabled={btnDisable}
								// >
								// 	Upload
								// </Button>
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={uploadSampleFileOfCurrencyRates}
									disabled={btnDisable}
								// endIcon={<SaveIcon />}
								>
									Upload <PublishIcon />
								</CustomButton>
							)}

							{/* <Button  
                style={{
                  backgroundColor: "#00b9f5", 
                  color: "white",
                }}
                variant="contained"
                className="riskRuleButton"
                onClick={uploadSampleFileOfCurrencyRates}
                endIcon={<PublishIcon />}
                disabled={btnDisable}
              // disabled="true"
              >
                Upload
              </Button> */}
						</Grid>
					</Grid>
				</Card>
			</Layout>
		</>
	);
};

export default ConversionRate;
